import { AssignedUserType } from '../../enums';
import { canRequestSlot } from '../can-request-slot/can-request-slot';
import { CanRequestSlotInput } from '../can-request-slot/interfaces';

export const hasUnassignedRequestableSlot = (params: Omit<CanRequestSlotInput, 'slot'>): boolean =>
  canRequestSlot({ ...params, slot: AssignedUserType.primary }) ||
  canRequestSlot({ ...params, slot: AssignedUserType.backup });
